import { match, Route, Switch } from 'react-router-dom';

import NavBar, { View } from '../../../components/NavBar';
import AppointmentAction from '../AppointmentAction';
import Loader from '../../../components/Loader';
import NoCookies from '../../Login/NoCookies';

import loginStyles from '../../Login/index.module.css';
import { useTheme } from '../../../hooks/common/useTheme';

interface Props {
  match: match;
}

const Router: React.FC<Props> = ({ match }) => {
  const { isThemeLoading } = useTheme();

  if (isThemeLoading) return <Loader />;

  return (
    <div className={loginStyles.LoginWrapper}>
      <NavBar view={View.Login} />
      <div className={loginStyles.Login}>
        <NoCookies />
        <Switch>
          <Route
            path={`${match.path}/:ehrTimeSlotBookingId/cancel`}
            component={AppointmentAction}
          />
        </Switch>
      </div>
    </div>
  );
};

export default Router;
